import React from 'react';
import { Dropdown } from 'antd';
import { identity } from 'lodash-es';
import Button from './Button';

function ButtonDropdown(_ref) {
  var children = _ref.children,
      dataTestId = _ref['data-testid'],
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? '' : _ref$text,
      type = _ref.type,
      icon = _ref.icon,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? identity : _ref$onClick;
  return (
    /*#__PURE__*/
    // @ts-ignore
    React.createElement(Dropdown, {
      overlay: children,
      trigger: ['click']
    }, /*#__PURE__*/React.createElement(Button, {
      "data-testid": dataTestId,
      icon: icon,
      onClick: onClick,
      type: type
    }, text))
  );
}

export default ButtonDropdown;